import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8dd715ca&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=8dd715ca&prod&lang=scss"
import style1 from "vue-dialog-drag/dist/vue-dialog-drag.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./index.vue?vue&type=style&index=2&id=8dd715ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd715ca",
  null
  
)

export default component.exports